<template>
  <div>
    <v-progress-linear
      v-if="automationRequestLoader"
      color="accent"
      indeterminate
    >
    </v-progress-linear>
    <v-card style="border-radius: 10px">
      <v-toolbar flat dense>
        <span class="beez-bold">Automation Request Details</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn slot="activator" flat icon @click="goToTaskList">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
          <span>Goto Automation Request List</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12 md6 lg4 xl3>
              <div class="text-xs-left">
                <br />
                <div>Request Number</div>
                <div class="subheading">
                  AR{{ automationRequest.requestNumber }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4 xl3>
              <div class="text-xs-left">
                <br />
                <div>Requested By</div>
                <div class="subheading">
                  {{ automationRequest.requestedByName }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4 xl3>
              <div class="text-xs-left">
                <br />
                <div>Business Reason</div>
                <div class="subheading">
                  {{ automationRequest.businessReason }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4 xl3>
              <div class="text-xs-left">
                <br />
                <div>Requested At</div>
                <div class="subheading">
                  {{ getLocalTime(automationRequest.createdAt) }}
                </div>
                <br />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg4 xl3>
              <div class="text-xs-left">
                <br />
                <div>Status</div>
                <div class="subheading">
                  {{ getStatus(automationRequest.serviceStatus).currentStatus }}
                </div>
                <br />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <automation-request-view
          v-if="automationRequest"
          :automation-request="automationRequest"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AutomationRequestView from '@/components/self-service/AutomationRequestView.vue'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import marked from 'marked'
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'ARCard',
  components: { AutomationRequestView },
  mounted() {
    this.getSelectedFromRoute()
  },
  data() {
    return {
      automationRequestLoader: false,
      automationRequestId: null,
      automationRequest: null
    }
  },
  methods: {
    getStatus(input) {
      let obj = {}
      switch (input) {
        case 'RAISED':
          obj.color = 'error'
          obj.icon = 'error'
          obj.currentStatus = 'Request raised (Not processed)'
          obj.errorStatus = true
          break
        case 'RECEIVED':
          obj.color = 'info'
          obj.icon = 'done'
          obj.currentStatus = 'Request received'
          obj.errorStatus = false
          break
        case 'SERVICED':
          obj.color = 'success'
          obj.icon = 'done_all'
          obj.currentStatus = 'Request serviced'
          obj.errorStatus = false
          break
        case 'IN_PROGRESS':
          obj.color = 'info'
          obj.icon = 'directions_run'
          obj.currentStatus = 'Request being serviced'
          obj.errorStatus = false
          break
        case 'AWAITING_USER_INPUTS':
          obj.color = 'info'
          obj.icon = 'mdi-approval'
          obj.currentStatus = 'Request waiting for user approval'
          obj.errorStatus = false
          break
        case 'OBSOLETE':
          obj.color = 'error'
          obj.icon = 'archive'
          obj.currentStatus = 'Request failed'
          obj.errorStatus = true
          break
        case 'FAILED':
          obj.color = 'error'
          obj.icon = 'error'
          obj.currentStatus = 'Request failed'
          obj.errorStatus = true
          break
        default:
          obj.color = 'error'
          obj.icon = 'error'
          obj.currentStatus = 'Not processed'
          obj.errorStatus = true
          break
      }
      return obj
    },
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    async getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'automation-request') {
        if (this.$route.params && this.$route.params.hexId) {
          this.automationRequestId = this.$route.params.hexId
          this.getAutomationRequest()
        }
      } else {
        this.$router.replace({ name: 'home' }).catch()
      }
    },
    getAutomationRequest() {
      this.automationRequestLoader = true
      axios
        .get(
          `/api/v1/automationRequests/${this.automationRequestId}?projection=withServiceStatus`
        )
        .then(res => {
          this.automationRequest = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.automationRequestLoader = false
        })
    },
    goToTaskList() {
      if (this.selfService) {
        this.$router.push({
          name: 'service-ar-history',
          params: { hexId: this.selfService.hexId }
        })
      } else {
        this.$router.push({ name: 'home' })
      }
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    compiledMD() {
      return marked(this.selfService.documentation)
    }
  }
}
</script>

<style scoped></style>
